import { STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { privateCompanyDefaultFolderTemplatesManager } from '@inpart-io/padme-iap';
import { type IDefaultFolderTemplate } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

export const RETRIEVE_TEMPLATE = 'retrieveTemplate';

export const actions: ActionTree<IDefaultFolderTemplate, unknown> = {
    async [RETRIEVE_TEMPLATE](context): Promise<number | undefined> {
        const result = await privateCompanyDefaultFolderTemplatesManager.getTemplate();

        if (result !== undefined) {
            void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
        }
        return result?.dobjId;
    }
};
